import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import {
  getExchangeAntispamActiveStateGridOptions,
  getExchangeAntispamMainActionGridOptions,
  getExchangeApplyToRuleGridOptions,
  getExchangeRuleSendersGridOptions,
} from '../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { ExchangeAntimalwareRule, ExchangeAntispamRuleActionType } from '@nirvana/shared/dtos/types/policies/common';
import { html, TemplateResult } from 'lit';

export enum Column {
  PRIORITY = 1,
  RULE_NAME = 2,
  ACTIVE = 3,
  APPLY_TO = 4,
  MAIN_ACTION = 5,
  SENDERS = 6,
  RECIPIENTS = 7,
}

export enum ColumnKeys {
  PRIORITY = 'defaultPositionInGrid',
  RULE_NAME = 'name',
  ACTIVE = 'activeState',
  APPLY_TO = 'applyTo',
  MAIN_ACTION = 'mainAction',
  SENDERS = 'senders',
  RECIPIENTS = 'recipients',
}

export const GRID_COLUMNS = [
  Column.PRIORITY,
  Column.RULE_NAME,
  Column.ACTIVE,
  Column.APPLY_TO,
  Column.MAIN_ACTION,
  Column.SENDERS,
  Column.RECIPIENTS,
];
export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.PRIORITY,
  ColumnKeys.RULE_NAME,
  ColumnKeys.ACTIVE,
  ColumnKeys.APPLY_TO,
  ColumnKeys.MAIN_ACTION,
  ColumnKeys.SENDERS,
  ColumnKeys.RECIPIENTS,
];

export const FILTERS = [
  { [ColumnKeys.RULE_NAME]: { contains: '' } },
  { [ColumnKeys.ACTIVE]: { in: [] } },
  { [ColumnKeys.APPLY_TO]: { in: [] } },
  { [ColumnKeys.MAIN_ACTION]: { in: [ExchangeAntispamRuleActionType.DELIVER] } },
  { [ColumnKeys.SENDERS]: { in: [] } },
  { [ColumnKeys.RECIPIENTS]: { in: [] } },
];

//add translateFn to the columnName
export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.PRIORITY,
      key: ColumnKeys.PRIORITY,
      columnName: translateFn('Priority'),
      type: ColumnType.NUMBER,
      removable: false,
      filteringDisabled: true,
    },
    {
      column: Column.RULE_NAME,
      key: ColumnKeys.RULE_NAME,
      columnName: translateFn('Rule name'),
      type: ColumnType.STRING,
      sortable: false,
      removable: false,
      editingDisabled: true,
    },
    {
      column: Column.ACTIVE,
      key: ColumnKeys.ACTIVE,
      columnName: translateFn('Status'),
      type: ColumnType.ENUM,
      values: getExchangeAntispamActiveStateGridOptions(),
      sortable: false,
      removable: false,
      editingDisabled: true,
    },
    {
      column: Column.APPLY_TO,
      key: ColumnKeys.APPLY_TO,
      columnName: translateFn('Applies to'),
      values: getExchangeApplyToRuleGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.MAIN_ACTION,
      key: ColumnKeys.MAIN_ACTION,
      columnName: translateFn('Main action'),
      values: getExchangeAntispamMainActionGridOptions(),
      type: ColumnType.ENUM,
      sortable: false,
      removable: false,
      editingDisabled: true,
    },
    {
      column: Column.SENDERS,
      key: ColumnKeys.SENDERS,
      columnName: translateFn('Senders'),
      values: getExchangeRuleSendersGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
    {
      column: Column.RECIPIENTS,
      key: ColumnKeys.RECIPIENTS,
      columnName: translateFn('Recipients'),
      values: getExchangeRuleSendersGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
  ];
}

export function nameCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ExchangeAntimalwareRule }
): TemplateResult {
  // default rule must be translated
  const cellValue = rowData.item.default ? translateFn('Default rule') : rowData.item.name;
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${cellValue}</span
  >`;
}
